import { defineRecipe } from '@plurall/elo-v3';

export const scrollTabsRootRecipe = defineRecipe({
  className: 'scroll-tabs',
  base: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    maxHeight: '100%',
    minHeight: 0,
    overflow: 'hidden',
  },
  variants: {
    variant: {
      line: {},
      outline: {},
    },
  },
  defaultVariants: { variant: 'line' },
});

export const scrollTabsListRecipe = defineRecipe({
  className: 'scroll-tabs-list',
  base: {
    flexShrink: 0,
  },
});

export const scrollTabsContentRecipe = defineRecipe({
  className: 'scroll-tabs-content',
  base: {
    overflowY: 'auto',
    overflowX: 'hidden',
    flex: '1 1 auto',
    minHeight: 0,
    position: 'relative',
    scrollBehavior: 'smooth',

    '&::-webkit-scrollbar': { width: '8px' },
    '&::-webkit-scrollbar-track': { background: 'transparent' },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(0, 0, 0, 0.2)',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: 'rgba(0, 0, 0, 0.3)',
    },
  },
});
